import React from 'react';
import { Stack } from '@mui/material';
import { styled } from '@mui/system';
import { ContainerLayout } from 'components/ContainerLayout/ContainerLayout';
import { useLayoutElementsHeight } from 'hooks/useLayoutElementsHeight';
import { ResourcesContent } from 'components/Resources/ResourcesContent';
import { useFeatureFlags } from 'features/DeveloperTools/hooks/useFeatureFlags';
import { FeatureFlagKeys } from 'features/DeveloperTools/config/constants';
import { ResourceFeature } from './ResourceFeature';

const ScrollableContainer = styled(Stack)(({ theme }) => {
  const { commonContentHeight } = useLayoutElementsHeight();

  return {
    height: commonContentHeight,
    overflowY: 'auto',
    overscrollBehaviorY: 'none',
    justifyContent: 'safe center',
    alignItems: 'center',
    background: `linear-gradient(to top left, 
    ${theme.palette.brandTint.main} 0%, 
    ${theme.palette.brandTint.main} 50%, 
    ${theme.palette.brandBackgroundPrimary.main} 50%, 
    ${theme.palette.brandBackgroundPrimary.main} 100%)`,
  };
});

export const Resources = () => {
  const { isEnabled } = useFeatureFlags();
  const isResourceFeatureEnabled = isEnabled(FeatureFlagKeys.RESOURCE_FEATURE);
  if (isResourceFeatureEnabled) {
    return <ResourceFeature />;
  }

  return (
    <ContainerLayout>
      <ScrollableContainer>
        <ResourcesContent />
      </ScrollableContainer>
    </ContainerLayout>
  );
};
